class UtilDomBuilder
{
    /**
     * Creates a new dom element and appends it to a parent
     *
     * @param {Element} parent The parent element
     * @param {String} tagName The tag name of the new child
     * @param {Object} innerText The inner text of the new dom element (optional)
     * @param {Object} attributes An object of attributes for the new element (optional)
     * @param {Object} dataset An object of data-attributes for the new element (optional)
     * @returns {Element} Returns the new child element
     */
    static appendNewChild(parent, tagName, innerText = '', attributes = {}, dataset = {}) {
        let newChild = UtilDomBuilder.createNewElement(tagName, innerText, attributes, dataset);
        parent.appendChild(newChild);
        return newChild;
    }

    /**
     * Creates a new dom element and prepends it to a parent
     *
     * @param {Element} parent The parent element
     * @param {String} tagName The tag name of the new child
     * @param {String} innerText The inner text of the new dom element (optional)
     * @param {Object} attributes An object of attributes for the new element (optional)
     * @param {Object} dataset An object of data-attributes for the new element (optional)
     * @returns {Element} Returns the new child element
     */
    static prependNewChild(parent, tagName, innerText = '', attributes = {}, dataset = {}) {
        let newChild = UtilDomBuilder.createNewElement(tagName, innerText, attributes, dataset);
        parent.prepend(newChild);
        return newChild;
    }

    /**
     * Creates a new element
     *
     * @param {String} tagName The tag name of the new element
     * @param {String} innerText The inner text of the new element
     * @param {Object} attributes The attributes of the new element
     * @param {Object} dataset The dataset of the new element
     *
     * @returns {Element}
     */
    static createNewElement(tagName, innerText = '', attributes = {}, dataset = {}) {
        let newElement = document.createElement(tagName);
        if (innerText) {
            newElement.innerText = innerText;
        }
        if (attributes) {
            for(let name in attributes) {
                newElement.setAttribute(name, attributes[name]);
            }
        }
        if (dataset) {
            for(let key in dataset) {
                newElement.dataset[key] = dataset[key];
            }
        }
        return newElement;
    }

    /**
     * Creates a new dom element with CSS classes and appends it to a parent
     *
     * @param {Element} parent The parent element
     * @param {string} tagName The tag name of the new child
     * @param {Array} classes Class names as array
     * @param {string} innerText The inner text of the new dom element (optional)
     * @param {Object} dataset An object of data-attributes for the new element (optional)
     * @returns {Element} Returns the new child element
     */
    static appendNewChildWithClasses(parent, tagName, classes, innerText = '', dataset = {}) {
        let attributes = {"class": classes.join(" ")};
        return UtilDomBuilder.appendNewChild(parent, tagName, innerText, attributes, dataset);
    }
    /**
     * Creates a new dom element with CSS classes and prepends it to a parent
     *
     * @param {Element} parent The parent element
     * @param {String} tagName The tag name of the new child
     * @param {Array} classes Class names as array
     * @param {string} innerText The inner text of the new dom element (optional)
     * @param {Object} dataset An object of data-attributes for the new element (optional)
     * @returns {Element} Returns the new child element
     */
    static prependNewChildWithClasses(parent, tagName, classes, innerText = '', dataset = {}) {
        let attributes = {"class": classes.join(" ")};
        return UtilDomBuilder.prependNewChild(parent, tagName, innerText, attributes, dataset);
    }

    /**
     * Creates a new dom element with a CSS class and appends it to a parent
     *
     * @param {Element} parent The parent element
     * @param {string} tagName The tag name of the new parent
     * @param {Array} cssClass Class name
     * @param {string} innerText The inner text of the new dom element (optional)
     * @param {Object} dataset An object of data-attributes for the new element (optional)
     * @returns {Element} Returns the new child element
     */
    static appendNewChildWithClass(parent, tagName, cssClass, innerText = '', dataset = {}) {
        return UtilDomBuilder.appendNewChildWithClasses(parent, tagName, [cssClass], innerText, dataset);
    }

     /**
     * Creates a new dom element with a CSS class and prepends it to a parent
     *
     * @param {Element} parent The parent element
     * @param {string} tagName The tag name of the new child
     * @param {Array} cssClass CSS class name
     * @param {string} innerText The inner text of the new dom element (optional)
     * @param {Object} dataset An object of data-attributes for the new element (optional)
     * @returns {Element} Returns the new child element
     */
    static prependNewChildWithClass(parent, tagName, cssClass, innerText = '', dataset = {}) {
        return UtilDomBuilder.prependNewChildWithClasses(parent, tagName, [cssClass], innerText, dataset);
    }


    static insertNewChildBefore(parent, refNode, tagName, innerText = '', attributes = {}, dataset = {}) {
      let newChild = UtilDomBuilder.createNewElement(tagName, innerText, attributes, dataset);
      parent.insertBefore(newChild, refNode);
      return newChild;
    }

    static insertNewChildBeforeWithClasses(parent, refNode, tagName, classes, innerText = '', dataset = {}) {
      let attributes = {"class": classes.join(" ")};
      return UtilDomBuilder.insertNewChildBefore(parent, refNode, tagName, innerText, attributes, dataset);
    }

    static insertNewChildBeforeWithClass(parent, refNode, tagName, cssClass, innerText = '', dataset = {}) {
      return UtilDomBuilder.insertNewChildBeforeWithClasses(parent, refNode, tagName, [cssClass], innerText, dataset);
    }

}
export {UtilDomBuilder};
